import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { GetKey } from "../../../Helpers/GetKey";
import { useSelector } from "react-redux";

export const ModalClienteEquip = ({ element, setListado }) => {
  const { idcliente } = useSelector((store) => store.clientes);
  const closedModal = () => {
    var modal = document.getElementById("modal-contacto");
    modal.style.display = "none";
  };
  const [state, setState] = useState({
    equip: "",
    sucursal: "",
  });
  const [sucursales, setSucursales] = useState([]);
  useEffect(() => {
    if (element != null) {
      setState({
        equip: element.idequip,
        sucursal: element.sucursal,
      });
    } else {
      setState({
        equip: "",
        sucursal: "",
      });
    }
  }, [element]);
  useEffect(() => {
    request
      .get("Sucursales/Listado")
      .then((result) => {
        setSucursales(result);
      })
      .catch((error) => {
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  }, []);
  const onGuardar = () => {
    if (
      state.equip === undefined ||
      state.equip === null ||
      state.equip === ""
    ) {
      Swal.fire(
        "Clientes",
        "Favor de agregar el numero que tiene en equip el cliente",
        "error"
      );
      return;
    }
    if (
      state.sucursal === undefined ||
      state.sucursal === null ||
      state.sucursal === ""
    ) {
      Swal.fire(
        "Clientes",
        "Favor de agregar el numero que tiene en equip el cliente",
        "error"
      );
      return;
    }
    const post = {
      idcliente,
      idequip: state.equip,
      sucursal: GetKey(state.sucursal),
    };
    request
      .post("ClientesEQUIP", post)
      .then((result) => {
        setListado(result);
        closedModal();
      })
      .catch((error) => {
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };
  return (
    <div id="modal-contacto" class="modal">
      <div class="modal-content-clientes">
        <div class="modal-header-contacto">
          <span class="close" onClick={closedModal}>
            &times;
          </span>
          <div className="encabezado">
            <div className="titulo">
              {element === null ? "REGISTRAR ID EQUIP" : "ACTUALIZAR ID EQUIP"}
            </div>
            <div className="border-green"></div>
          </div>
        </div>
        <div class="modal-body-clientes">
          <Autocomplete
            fullWidth
            size="small"
            id="mediocontacto"
            freeSolo
            className="mb-15"
            value={state.sucursal}
            onChange={({ target }) =>
              setState({ ...state, sucursal: target.outerText })
            }
            options={sucursales.map(
              (option) => `${option.idsucursal} - ${option.sucursal}`
            )}
            renderInput={(params) => (
              <TextField {...params} label="Sucursales" />
            )}
            sx={{ mr: 1 }}
          />
          <TextField
            fullWidth
            label="ID EQUIP"
            size="small"
            color="success"
            className="mb-15"
            type="text"
            value={state.equip}
            onChange={({ target }) =>
              setState({
                ...state,
                equip: target.value.toUpperCase(),
              })
            }
          />
        </div>
        <div className="footer-guardar-domicilio">
          <div className="button-guardar" onClick={onGuardar}>
            Guardar
          </div>
        </div>
      </div>
    </div>
  );
};
